import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  storedMassSelectionController = null;

  connect() {
    this.element.addEventListener("turbo:submit-end", this.afterSubmitEvent);
  }

  disconnect() {
    this.element.removeEventListener("turbo:submit-end", this.afterSubmitEvent);
  }

  afterSubmitEvent = (event) => {
    if (event.detail.success === true) {
      this.massSelectionController.deselectAll();
    }
  };

  get massSelectionController() {
    if (!this.storedMassSelectionController) {
      const controllerElement = document.querySelector(
        "[data-controller*='mass-selection']"
      );

      this.storedMassSelectionController =
        this.application.getControllerForElementAndIdentifier(
          controllerElement,
          "mass-selection"
        );

      if (!this.storedMassSelectionController) {
        throw new Error("Multi item selection controller not found");
      }
    }
    return this.storedMassSelectionController;
  }
}
